import { View, ScrollView, FlatList, Dimensions, Pressable } from 'react-native';
import { Text, Divider, Chip, Button, HelperText, ActivityIndicator, FAB, IconButton, } from 'react-native-paper';
import * as React from 'react';
import { useDispatch, useSelector } from "react-redux";
import Preferance from '../constants/Preferances';
import Global from "../constants/global";
import { collection, doc, getFirestore, limit, onSnapshot, orderBy, query, setDoc, updateDoc, where } from "firebase/firestore";
const grade = [
    { min: 90, max: 100, grade: "A+" },
    { min: 80, max: 89, grade: "A" },
    { min: 70, max: 79, grade: "B+" },
    { min: 60, max: 69, grade: "B" },
    { min: 50, max: 59, grade: "C+" },
    { min: 40, max: 49, grade: "C" },
    { min: 33, max: 39, grade: "D" },
    { min: 0, max: 32, grade: "E" }
]
import { FlashList } from '@shopify/flash-list';
import ClassRow from '../components/ClassRow';
import DModal from '../components/DModal';
import { TouchableOpacity } from 'react-native-gesture-handler';
import { listsTask } from '../task/listTasks';
import { MaterialCommunityIcons } from '@expo/vector-icons';

export default function PrepareExams({ navigation, route }) {
    return <ScrollView>
        <Text style={{ padding: 8 }} variant="titleMedium">Verify details to Proceed with Markes & Rports</Text>
        <Details allExams={route.params.allExams} exam={route.params.exam} currentYear={route.params.currentYear} navigation={navigation} />
    </ScrollView>
}

const Details = ({ allExams, exam, currentYear, navigation }) => {
    const classList = useSelector((state) => state.list.Classes)
    const classTeacher = useSelector((state) => state.list.ClassTeacher)
    const [sortedClassList, setSortedClassList] = React.useState([])
    const teachers = useSelector(React.useMemo(Global.getUserList, []))
    const [teacherList, setTeacherList] = React.useState([])


    React.useEffect(() => {
        if (teachers) {
            const s: [] = teachers.filter(e => (e.retired !== true) && (e.type == Global.PRINCIPAL || e.type == Global.TEACHER || e.type == Global.VISITING_TEACHER))
            setTeacherList(s)
        }
    }, [teachers])

    React.useEffect(() => {
        if (classList) {

            const s: [] = []
            classList.map(p => {
                if (p.final) {
                    s.push({ ...p })
                }
            })
            const nnewP = s.sort((a, b) => a?.seq < b?.seq ? -1 : 0)

            setSortedClassList(nnewP)
        }
    }, [classList, currentYear])
    const pref = React.useContext(Preferance)

    return (
        <View>

            <FlashList
                data={sortedClassList}
                key="id"
                estimatedItemSize={70}
                keyboardShouldPersistTaps={'handled'}
                renderItem={({ item, index }) => {
                    
                    return <EClassRow allExams={allExams} cl={item} context={pref} classTeachers={classTeacher} exam={exam} teacherList={teacherList} currentYear={currentYear} navigation={navigation} />
                }

                } />

        </View >

    );


}

const EClassRow = ({ allExams, context, classTeachers, cl, exam, teacherList, currentYear, navigation }) => {
    const arr = useSelector(s => s.list.Arrangement)
    const s = useSelector(s => s.list.Subjects)
    const [subjects, setSubjects] = React.useState([])
    const [cls, setCls] = React.useState()
    const [ss, setSS] = React.useState([])
    const [classArrangement, setClassArrangement] = React.useState([])
    // //console.log("cl row exam", exam)
    React.useEffect(() => {
        const slist = s.filter(f => f.classNo == cl.classNo)
        const ns: [] = []
        slist.map(s => { ns.push({ ...s }) })
        const ns1 = Global.sortSubjects(ns)
        setSS(ns1)
    }, [s])


    React.useEffect(() => {
        const got = arr.find(f => f.year == currentYear)
        if (ss) {
            setClassArrangement(got)
            const g1 = Global.getTheBest("cl", got, cl.id, exam.exam)
            const ocl = { ...cl }
            ocl.classTeacher = g1
            setCls(ocl)
            const newSub = []
            ss.map(sub => {
                const nsub = sub
                const gt = Global.getTheBest("sub", got, cl.id + sub.id, exam.exam)
                if (gt) {
                    nsub.teacher = gt
                }
                newSub.push(nsub)
            })
            setSubjects(newSub)

        }
    }, [arr, ss, cl])


    return <View style={{ marginBottom: 15 }}>
        <ArrangementForCurrentYear currentYear={currentYear} />
        {cls && subjects.length && <ClassRowForEntry allExams={allExams} subjects={subjects} item={cls} context={context} navigation={navigation} currentYear={currentYear} exam={exam} />}
        <View style={{ paddingLeft: 40 }}>

            <ClassTeacher context={context} teacherList={teacherList} exam={exam} cl={cl} clsTeacher={cls?.classTeacher} currentYear={currentYear} />
            {
                subjects.map(subject =>
                    <SubjectTeacher classTeacherId={cls?.classTeacher?.teacherId} context={context} subject={subject} teacherList={teacherList} exam={exam} cl={cl} currentYear={currentYear} />
                )
            }
            <Divider leftInset />
        </View>
    </View >

}
const ArrangementForCurrentYear = ({ currentYear }) => {

    const dispatch = useDispatch()
    React.useEffect(() => {
        let lr
        if (currentYear) {
            const id = "arr" + currentYear
            const citiesRef = doc(getFirestore(), Global.ARRANGEMENT, id);
            lr = onSnapshot(
                citiesRef, { includeMetadataChanges: true },
                (docc) => {
                    const data = docc.data()

                    dispatch(listsTask.actions.updateActivity({
                        data: [{ data: data }],
                        type: Global.ARRANGEMENT,
                        isArray: true
                    }))
                });

        }
        return () => (lr && lr())
    })
    return <></>
}
const MarksheetMessage = ({ current, year, std, exam, lockStatus }) => {
    const [edit, setEdit] = React.useState({ mode: 0, message: "" })
    React.useEffect(() => {

        setEdit(p => ({ ...p, message: lockStatus?.message ? lockStatus?.message : "" }))
    }, [lockStatus])
    function save() {
        const classStamp = exam.name + std.id + year

        const r = doc(getFirestore(), Global.LOCK, classStamp)
        const data = {
            id: r.id,
            message: edit.message,
            messageBy: current?.current?.name ? current?.current?.name : ""
        }
        setDoc(r, data, { merge: true }).then(e => {
            setEdit(p => ({ ...p, mode: 0 }))
        })
    }
    return <View>
        <TouchableOpacity onPress={() => { setEdit(p => ({ ...p, mode: 1 })) }}>
            <View style={{ flexDirection: "row", alignItems: "center" }}>
                <Text><MaterialCommunityIcons name="pen" /> Marksheet Note </Text>
                {edit.mode == 0 && <Text>{edit.message}</Text>}
            </View>
        </TouchableOpacity>
        {
            edit.mode == 1 && <View style={{ flexDirection: "row" }}>
                <TextInput value={edit.message} onChangeText={(t) => {
                    setEdit(p => ({ ...p, message: t }))
                }} placeholder='Write note here...' />
                <Button mode="contained" onPress={save}>Save</Button>
            </View>
        }
    </View>
}


const SubjectTeacher = ({ context, classTeacherId, subject, teacherList, exam, cl, currentYear }) => {
    // const [ct, setCt] = React.useState()
    const [show, setShow] = React.useState(false)
    const [newTeacher, setNewTeacher] = React.useState(false)
    // const classTeachers = useSelector(s => s.list.ClassSubjectTeachersOnly)
    // const dispatch = useDispatch()
    // React.useEffect(() => {
    //     if (arrangement && classTeachers) {
    //         // //console.log("gatherihg", classTeachers, "CLID=", cl.id, ", SUBID=" + subject.id, exam.exam)
    //         const got = getTheBest("sub", arrangement, cl.id + subject.id, exam.exam)
    //         // +("gatherihg got", got)
    //         if (got) {
    //             setCt(got)
    //             // dispatch(listsTask.actions.updateClassTeachers({ type: "ClassTeachersOnly", classId: cl.id, teacher: got, check: "teacherId" }))
    //             dispatch(listsTask.actions.updateClassTeachers({ type: "ClassSubjectTeachersOnly", classId: cl.id + subject.id, subject: subject, teacher: got, onlyClassId: cl.id, examNo: exam.exam, year: currentYear }))
    //         }

    //     }

    // }, [arrangement, classTeachers])

    return <View>
        <Pressable onPress={() => {
            let clt = ""
            try {
                clt = classTeacherId//classTeachers[cl.id][0].teacherId
            } catch {

            }
            if (clt == context.current.id || context.current.type == Global.PRINCIPAL) {
                setShow(true)
            } else {
                alert("Only Class Teacher/Principal can change subject teacher.  Principal can also change class teacher")
            }
        }} style={{ flexDirection: "row" }}>
            <Text style={{ flex: 1 }} variant="titleMedium">{subject?.name}</Text>
            <Text style={{ flex: 1 }} variant={subject?.teacher?.teacherName ? "titleMedium" : "bodySmall"}>{subject?.teacher?.teacherName ? subject?.teacher?.teacherName : "(click to select teacher)"}</Text>
            {/* <DIcon color='gray' icon="pen"></DIcon> */}
        </Pressable>
        <DModal
            isVisible={show}
            close={() => setShow(false)}>
            <Text variant="headlineMedium">{"Select " + subject?.name + " Teacher "}</Text>
            <Text variant="bodySmall">{"Subject teacher selected here will be Subject teacher for this exam onward, till changed"}</Text>
            <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
                {teacherList.map((e, i) => {
                    return <Chip id={i + "s"} style={{ margin: 2 }} selected={e.id == newTeacher.id}
                        onPress={() => {
                            setNewTeacher(e)
                        }}>{e.name}</Chip>
                }
                )}
            </View>
            <View style={{ flexDirection: "row" }}>
                <Button onPress={() => { setShow(false) }} style={{ flex: 1 }} mode="text">Cancel</Button>
                <SubjectTeacherSaveButton subject={subject} cl={cl} exam={exam} newTeacher={newTeacher} currentYear={currentYear} done={() => setShow(false)} />
            </View>
        </DModal>
    </View>

}
const SubjectTeacherSaveButton = ({ subject, cl, exam, newTeacher, currentYear, done }) => {
    const [working, setWorking] = React.useState({ working: false, status: 0 })
    async function save() {
        const id = "arr" + currentYear
        const ref = doc(getFirestore(), Global.ARRANGEMENT, id)
        try {
            if (currentYear) {
                setDoc(ref, {
                    id: "arr" + currentYear, year: currentYear, [`sub${cl.id}${subject.id}${exam.exam}`]: {
                        teacherId: newTeacher.id,
                        teacherName: newTeacher.name,
                        stamp: new Date().getTime()
                    }
                }, { merge: true })
                return 1
            } else {
                return -1
            }
        } catch {
            return -1
        }
    }
    return <Button loading={working.working} icon={working.status == 1 ? "check-bold" : working.status == -1 ? "alert" : undefined} onPress={() => {
        save().then(e => {
            setWorking({ working: false, status: e })
            setTimeout(() => done(), 1000)
        })
    }} style={{ flex: 1 }} mode="contained">Save</Button>
}

const ClassTeacher = ({ context, cl, teacherList, exam, currentYear, clsTeacher }) => {
    // const [ct, setCt] = React.useState()
    const [show, setShow] = React.useState(false)
    const [newTeacher, setNewTeacher] = React.useState(false)
    // const dispatch = useDispatch()
    // React.useEffect(() => {
    //     if (arrangement) {

    //         const got = getTheBest("cl", arrangement, cl.id, exam.exam)
    //         if (got) {
    //             setCt(got)
    //             dispatch(listsTask.actions.updateClassTeachers({ type: "ClassTeachersOnly", classId: cl.id, teacher: got, onlyClassId: cl.id, examNo: exam.exam, year: currentYear }))
    //         }

    //     }

    // }, [arrangement])

    return <View>
        <Pressable onPress={() => {
            if (context?.current?.supervisor)
                setShow(true)
        }
        } style={{ flexDirection: "row", paddingBottom: 10 }}>
            <Text style={{ flex: 1, fontWeight: "bold" }} variant="bodySmall">Class Teacher </Text>
            <Text style={{ flex: 1, fontWeight: "bold" }} variant={clsTeacher?.teacherName ? "titleMedium" : "bodySmall"}>{clsTeacher?.teacherName ? clsTeacher?.teacherName : "(click to change teacher)"}</Text>
        </Pressable>

        <DModal
            isVisible={show}
            close={() => setShow(false)}>
            <Text variant="headlineMedium">{"Select " + cl.name + (cl.div ? cl.div : "") + " Class Teacher"}</Text>
            <Text variant="bodySmall">{"Class teacher selected here will be class teacher for this exam onward, till changed"}</Text>
            <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
                {teacherList.map((e, i) => {
                    return <Chip id={i + "s"} style={{ margin: 2 }} selected={e.id == newTeacher.id}
                        onPress={() => {
                            setNewTeacher(e)
                        }}>{e.name}</Chip>
                }
                )}
            </View>
            <View style={{ flexDirection: "row" }}>
                <Button onPress={() => { setShow(false) }} style={{ flex: 1 }} mode="text">Cancel</Button>
                <ClassTeacherSaveButton cl={cl} exam={exam} newTeacher={newTeacher} currentYear={currentYear} done={() => setShow(false)} />
            </View>
        </DModal>
    </View>
}

const ClassTeacherSaveButton = ({ cl, exam, newTeacher, currentYear, done }) => {
    const [working, setWorking] = React.useState({ working: false, status: 0 })

    async function save() {
        // const id = "arr" + currentYear
        // const ref = doc(getFirestore(), Global.ARRANGEMENT, id)
        try {
            Global.save({ currentYear: currentYear, classId: cl.id, examNo: exam.exam, teacherId: newTeacher.id, teacherName: newTeacher.name })
            // setDoc(ref, {
            //     id: "arr" + currentYear, year: currentYear,
            //     [`cl${cl.id}${exam.exam}`]: {
            //         teacherId: newTeacher.id,
            //         teacherName: newTeacher.name,
            //         stamp: new Date().getTime()
            //     }
            // }, { merge: true })
            // // setDoc(ref, dat, { merge: true })
            // return 1
        } catch {
            return -1
        }
    }
    return <Button loading={working.working} icon={working.status == 1 ? "check-bold" : working.status == -1 ? "alert" : undefined} onPress={() => {
        save().then(e => {
            setWorking({ working: false, status: e })
            setTimeout(() => done(), 1000)
        })
    }} style={{ flex: 1 }} mode="contained">Save</Button>
}

const ClassRowForEntry = ({ allExams, ClassTeacher, subjects, item, context, navigation, currentYear, exam }) => {
    const [show, setShow] = React.useState(false)
    const [lockStatus, setLockStatus] = React.useState({
        id: true, name: "", locked: false, stamp: 0, loading: true
    })
    const dispatch = useDispatch()
    const lock = useSelector(s => s.list.LockStatus[item.id + currentYear + exam.name])
    // //console.log("prepareExam 1", exam)
    React.useEffect(() => {
        if (lock) {
            //  //console.log("Lockmess", lock)
            setLockStatus(p => ({
                ...p,
                id: lock.id ? lock.id : "",
                name: lock.name ? lock.name : "",
                stamp: lock.stamp ? lock.stamp : 0,
                locked: lock.locked == undefined ? false : lock.locked,
                loading: false,
            }))
        }
    }, [lock])

    React.useEffect(() => {
        const stamp = exam.name + item.id + currentYear
        const yearStamp = item.id + currentYear + ""
        const db = getFirestore()
        const citiesRef = collection(db, Global.RESULTREPORT);
        const q = query(citiesRef, where("classYearStamp", "==", yearStamp))
        // //console.log(item.id, yearStamp, stamp)
        const l = onSnapshot(
            q, { includeMetadataChanges: true },
            (docc) => {
                let tklist: [] = []
                docc.docChanges().forEach((change) => {
                    tklist.push(change.doc.data())
                })
                const data = tklist.find(s => s.id === stamp)

                // //console.log("ToVerify",currentYear,  yearStamp, tklist, data)
                dispatch(listsTask.actions.setReportsLog({
                    year: currentYear,
                    classId: item.id,
                    id: yearStamp,
                    list: tklist
                }))
                if (data) {
                    try {
                        const Tarij = data?.Tarij
                        const SubjectSheet = data?.SubjectSheet
                        const SummarySheet = data?.SummarySheet
                        const Marksheets = data?.Marksheets
                        const SavedBy = {
                            id: data?.savedBy?.id,
                            name: data?.savedBy?.name,
                            stamp: data?.savedBy?.stamp,
                            locked: data?.locked,
                        }
                        dispatch(listsTask.actions.setReports({
                            year: currentYear,
                            classId: item.id,
                            id: stamp,
                            examName: exam.name,
                            tarij: Tarij,
                            SubSheet: SubjectSheet,
                            SummSheet: SummarySheet,
                            Marksheets: Marksheets,
                            lockStatus: SavedBy
                        }))

                    } catch (e) { }
                } else {
                    setLockStatus(p => ({
                        ...p, loading: false,
                    }))
                }
            });

        const medRef = doc(db, Global.MEDICALMARKS, yearStamp);
        const ml = onSnapshot(
            medRef, { includeMetadataChanges: true },
            (docc) => {
                if (docc.exists()) {
                    const t = docc.data()
                    const tt = { ...t }
                    delete tt.id
                    delete tt.year
                    dispatch(listsTask.actions.setMedicalmMarks({
                        yearStamp: yearStamp,
                        data: tt
                    }))

                }
            });


        return () => {
            if (l) {
                l()
            }
            if (ml) {
                ml()
            }

        }
    }, [])

    React.useEffect(() => {
        let got = context?.current?.type == Global.PRINCIPAL || context?.current?.supervisor == true
        // //console.log(item)
        if (!got) {
            got = subjects.find(s => s?.teacher?.teacherId == context.current?.id)
            // got = onlyTeachers[item.id + currentYear + exam.exam]?.find(f => f == context.current?.id)
        }
        // //console.log(got, subjects, item)
        if (got) {
            setShow(true)
        }
    }, [item, subjects])
    // //console.log("prepareExam", exam)
    return <TouchableOpacity
        style={{ flexDirection: "row" }}
        onPress={() => {
            if (show && !lockStatus.loading) {
                navigation.navigate("PrepareMarks", { year: currentYear, std: item, exam: exam, subjects: subjects, lockStatus: lockStatus, allExams: allExams })
            }
        }}>
        {item ? <ClassRow item={item} hideDivider={true} /> : <></>}

        {show && <View style={{ flexDirection: "row", alignItems: "center" }}>
            <ActivityIndicator animating={lockStatus.loading} />
            <View style={{}}>
                <Text style={{ padding: 10, borderRadius: 5, backgroundColor: lockStatus.locked ? "#00FA9A" : "orange", color: "black" }}> {lockStatus.locked && <MaterialCommunityIcons name='check' />} {lockStatus.locked ? "View Reports" : "Marks & Reports"}</Text>
                <Text style={{ color: "black" }}> {lockStatus?.locked && lockStatus.name && <MaterialCommunityIcons name='lock' />} {lockStatus.name ? ("Locked By:" + lockStatus.name) : ""}</Text>
            </View>
        </View>}
    </TouchableOpacity>

}



